export default "/staticreactui/static/media/static/media/customer3.0c676936.webp";